'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _renderProp = require('../utils/propTypes/renderProp');

var RenderProps = _interopRequireWildcard(_renderProp);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TwoWayTransition = function (_React$Component) {
  _inherits(TwoWayTransition, _React$Component);

  function TwoWayTransition(props) {
    _classCallCheck(this, TwoWayTransition);

    var _this = _possibleConstructorReturn(this, (TwoWayTransition.__proto__ || Object.getPrototypeOf(TwoWayTransition)).call(this, props));

    var children = props.children;

    _this.state = {
      cachedChildren: children,
      hidden: children == null,
      transitioning: false
    };
    _this.stopTransition = _this.stopTransition.bind(_this);
    return _this;
  }

  _createClass(TwoWayTransition, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      var _props = this.props,
          transitionOnMount = _props.transitionOnMount,
          children = _props.children,
          duration = _props.duration;

      if (children != null) {
        this.cacheChildren(children);
        if (transitionOnMount) {
          this.setState({
            hidden: true
          });
          this.startTransition(false, duration);
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          children = _props2.children,
          duration = _props2.duration,
          transitionOnUpdate = _props2.transitionOnUpdate;

      // ⚠️ This condition prevents infinite loops! ⚠️

      if (prevProps.children === children) return;

      if (children != null) {
        this.cacheChildren(children);
      }

      if (transitionOnUpdate) {
        if (prevProps.children == null && children != null) {
          this.startTransition(false, duration);
        } else if (prevProps.children != null && children == null) {
          this.startTransition(true, duration);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'cacheChildren',
    value: function cacheChildren(children) {
      if (children === this.state.cachedChildren) return;
      this.setState({
        cachedChildren: children
      });
    }
  }, {
    key: 'startTransition',
    value: function startTransition(hidden, duration) {
      var _this2 = this;

      // Clear any other pending timers on the component
      cancelAnimationFrame(this._frame);
      clearTimeout(this._timeout);

      // Yes, two RAFs are the correct amount of time to wait before applying a transition. If you
      // don't believe me, watch: https://www.youtube.com/watch?v=cCOL7MC4Pl0
      this._frame = requestAnimationFrame(function () {
        _this2._frame = requestAnimationFrame(function () {
          if (!_this2._isMounted) return;
          _this2.setState({
            hidden: hidden,
            transitioning: true
          });
          _this2.setTransitionEndTimeout(duration);
        });
      });
    }
  }, {
    key: 'stopTransition',
    value: function stopTransition() {
      if (!this._isMounted) return;
      this.setState({
        transitioning: false
      });
      if (this.state.hidden) {
        this.cacheChildren(null);
      }
    }
  }, {
    key: 'setTransitionEndTimeout',
    value: function setTransitionEndTimeout(duration) {
      this._timeout = setTimeout(this.stopTransition, duration);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          __transitionOnMount = _props3.transitionOnMount,
          __transitionOnUpdate = _props3.transitionOnUpdate,
          children = _props3.children,
          duration = _props3.duration,
          Wrapper = _props3.Wrapper,
          rest = _objectWithoutProperties(_props3, ['transitionOnMount', 'transitionOnUpdate', 'children', 'duration', 'Wrapper']);

      var _state = this.state,
          hidden = _state.hidden,
          cachedChildren = _state.cachedChildren,
          transitioning = _state.transitioning;

      return _react2.default.createElement(
        Wrapper,
        _extends({
          duration: duration,
          hidden: hidden,
          transitioning: transitioning
        }, rest),
        children != null ? children : cachedChildren
      );
    }
  }]);

  return TwoWayTransition;
}(_react2.default.Component);

var wrapperPropTypes = {
  duration: _react.PropTypes.number,
  hidden: _react.PropTypes.bool.isRequired,
  transitioning: _react.PropTypes.bool.isRequired
};

TwoWayTransition.propTypes = {
  transitionOnMount: _react.PropTypes.bool.isRequired,
  transitionOnUpdate: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node,
  duration: _react.PropTypes.number.isRequired,
  Wrapper: RenderProps.getPropType({ propTypes: { wrapperPropTypes: wrapperPropTypes } }).isRequired
};

TwoWayTransition.defaultProps = {
  children: null,
  transitionOnMount: false,
  transitionOnUpdate: true
};

exports.default = TwoWayTransition;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/transitions/TwoWayTransition.js
// module id = 258
// module chunks = 0